<template>
  <validation-observer ref="formIndividual">
    <b-form @submit.prevent>
      <b-row>
        <!-- username -->
        <b-col cols="12" sm="10">
          <validation-provider
            rules="required"
            v-slot="{ errors }"
            name="Customer Source"
            vid="Customer Source"
          >
            <b-form-group label="Customer Source" label-for="h-First">
              <b-form-select
                v-model="individual.profile.source"
                :options="sourceDDL"
              />
              <small v-if="errors.length" class="text-danger">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" sm="2" class="d-flex align-items-center">
          <b-button
            variant="primary"
            class="w-100"
            @click="showModal('SOURCE')"
          >
            Add Source
          </b-button>
        </b-col>
        <b-col cols="12">
          <b-form-group label="First Name" label-for="h-First">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="First Name"
              vid="First Name"
            >
              <b-form-input
                id="h-First"
                placeholder="First Name"
                v-model="individual.fName"
              />
              <small v-if="errors.length" class="text-danger">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Last Name" label-for="h-Last">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="Last Name"
              vid="Last Name"
            >
              <b-form-input
                id="h-Last"
                placeholder="Last Name"
                v-model="individual.lName"
              />
              <small v-if="errors.length" class="text-danger">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>


          
        </b-col>

        <b-col cols="12">
            <validation-provider
            rules="required"
              v-slot="{ errors }"
              name="Sales Person"
              vid="Sales Person"
            >
              <b-form-group label="Sales Person" label-for="h-First">
                <b-form-select
                  v-model="individual.salesPersonId"
                  :options="salesPersonDDL"
                />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

        <b-col cols="12">
          <b-button
            v-on:click="isCollapseInd = !isCollapseInd"
            variant="primary"
          >
            {{ this.isCollapseInd ? "See More" : "See Less" }}
          </b-button>
        </b-col>

        <b-col v-if="!isCollapseInd" cols="12">
          
          <b-col cols="12">
            <validation-provider v-slot="{ errors }" name="Title" vid="Title">
              <b-form-group label="Title" label-for="h-First">
                <b-form-select v-model="individual.title" :options="options" />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>


          <b-col cols="12">
            <b-form-group label="ERN" label-for="h-brn">
              <b-form-input
                id="h-brn"
                placeholder="ERN"
                v-model="individual.brn"
              />
            </b-form-group>
          </b-col>


          <!-- email -->
          <b-col cols="12">
            <validation-provider v-slot="{ errors }" name="email" vid="email" rules="email_regex">
              <b-form-group label="Email" label-for="d-email">
                <b-form-input
                  id="d-email"
                  type="email"
                  placeholder="Enter your email (e.g., example@domain.com)"
                  v-model="individual.email"
                />
                <small v-if="errors.length" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- DOB  -->
          <b-col cols="12">
            <b-form-group label="Date of Birth" label-for="dob">
              <flat-pickr
                v-model="individual.dob"
                class="form-control"
                :config="config"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Address" label-for="h-Address">
              <b-form-input
                id="h-Address"
                placeholder="Address"
                v-model="individual.addressLine1"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group label="Street Name" label-for="h-Street">
              <b-form-input
                id="h-Street"
                placeholder="Street Name"
                v-model="individual.addressLine2"
              />
            </b-form-group>
          </b-col>

          <b-col cols="10">
            <b-form-group label="City" label-for="h-City">
              <b-form-select
                v-model="individual.profile.city"
                :options="cityDDL"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('CITY')"
            >
              Add City
            </b-button>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Tel" label-for="h-tel">
              <b-form-input
                id="h-tel"
                placeholder="Tel"
                type="number"
                onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                v-model="individual.tel"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-form-group
              label="Category"
              label-for="h-specialInstructions"
            >
              <b-form-input
                id="h-specialInstructions"
                placeholder="Category"
                v-model="individual.fieldInstruction"
              />
            </b-form-group>
          </b-col>

          <b-col cols="10">
            <b-form-group label="Job Title" label-for="h-title">
              <b-form-select
                v-model="individual.profile.jobTitle"
                :options="jobTitleDDL"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('JobTitle')"
            >
              Add Job Title
            </b-button>
          </b-col>
          <!-- Hobbies -->
          <b-col cols="10">
            <b-form-group label="Hobbies" label-for="h-title">
              <v-select
                taggable
                multiple
                push-tags
                placeholder="Add Hobbies"
                label="itemTitle"
                v-model="individual.profile.hobbies"
                :options="hobbiesDDL"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('HOBBIE')"
            >
              Add Hobby
            </b-button>
          </b-col>
          <!-- products interested in  -->
          <b-col cols="10">
            <b-form-group label="Products Interested in" label-for="h-title">
              <v-select
                taggable
                multiple
                push-tags
                placeholder="Add Products Interested in"
                label="itemTitle"
                v-model="individual.profile.productsInterestedIn"
                :options="productInterestDDL"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="2" class="d-flex align-items-center">
            <b-button
              variant="primary"
              class="w-100"
              @click="showModal('PRODUCTINTEREST')"
            >
              Add Product Interest
            </b-button>
          </b-col>
          <!-- Segment -->
          <b-col cols="12">
            <b-form-group label="Marketing Segment" label-for="h-title">
              <v-select
                taggable
                multiple
                push-tags
                placeholder="Add Marketing Segments"
                label="itemTitle"
                v-model="individual.profile.marketingSegments"
                :options="segmentOptions"
              />
            </b-form-group>
          </b-col>
        </b-col>
      </b-row>
      <CustomFieldsDetails
       v-if="!isCollapseInd"
        :AdditionalFields="individual.additionalFields"
        :ModuleReference="'LeadClient'"
        @onchange="additionalFieldChanges"
      ></CustomFieldsDetails>
    </b-form>
    <b-modal :id="modalId" :title="modalTitle" hide-footer>
      <b-form @submit.prevent="addItem">
        <b-form-group  label-for="input-new-item"> 
          <b-form-input
            id="input-new-item"
            v-model="newItem"
            required
            placeholder="Enter new item"
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary">Add</b-button>
      </b-form>

      <div class="p-1" style="max-height: 500px; overflow-y: auto">
        <b-table
          striped
          hover
          :items="modalOptions"
          responsive
          :fields="fields"
        >
          <template v-slot:cell(name)="data">
            {{
              modalType === "PRODUCTINTEREST" || "HOBBIE"
                ? data.item.itemTitle
                : data.item.text
            }}
          </template>
          <template #cell(actions)="data">
            <b-button
              size="sm"
              variant="danger"
              @click="deleteItem(data.item.value)"
              >Delete</b-button
            >
          </template>
        </b-table>
      </div>
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormText,
  BFormTextarea,
  BDropdown,
  BDropdownItem,
  BFormDatalist,
  BFormSelect,
  BModal,
  VBModal,
  BTable,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { fnSortingDropdown } from "@/libs/customFn";
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";
import { extend } from "vee-validate";

extend("email_regex", {
  validate: value =>
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value),
  message: "Please enter a valid email address in the format example@domain.com",
});

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BFormText,
    BButton,
    BFormDatalist,
    BDropdown,
    BDropdownItem,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    vSelect,
    flatPickr,
    BModal,
    VBModal,
    BTable,
    CustomFieldsDetails,
  },
  directives: {
    Ripple,
  },

  props: {
    individual: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      fields: [{ key: "name", sortable: true }, { key: "actions" }],
      optionsSalesPerson: [],
      sourceOptions: [],
      productInterestOptions: [],
      hobbiesOptions: [],
      cityOptions: [],
      jobTitleOptions: [],
      modalId: "",
      isCollapseInd: true,
      modalTitle: "",
      modalType: "",
      newItem: "",
      currentOptions: [],
      options: [
        { value: null, text: "Please select a title" },
        { value: "Mr", text: "Mr" },
        { value: "Mrs", text: "Mrs" },
        { value: "Ms", text: "Ms" },
      ],

      selected: "Select Social Media",
      ///////////////
      required,
      email,
      config: {
        wrap: true,
        maxDate: "today",
      },
    };
  },
  computed: {
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    ...mapGetters("customerModule", {
      details: "details",
      loading: "loading",
    }),
    ...mapGetters("segmentModule", {
      segments: "segments",
      loading: "loading",
    }),
    segmentOptions() {
      let segmentList = this.segments.map((segment) => {
        return {
          value: segment.segmentId,
          itemTitle: segment.name,
        };
      });
      return fnSortingDropdown(segmentList, "asc", "itemTitle");
    },

    modalOptions() {
      if (this.modalType === "PRODUCTINTEREST") {
        return this.productInterestOptions;
      } else if (this.modalType === "SOURCE") {
        return this.sourceOptions;
      } else if (this.modalType === "CITY") {
        return this.cityOptions;
      } else if (this.modalType === "JOBTITLE") {
        return this.jobTitleOptions;
      } else if (this.modalType === "HOBBIE") {
        return this.hobbiesOptions;
      }
      return []; // Return an empty array as fallback
    },
    sourceDDL() {
      return fnSortingDropdown(this.sourceOptions);
    },
    salesPersonDDL() {
      return fnSortingDropdown(this.optionsSalesPerson);
    },
    cityDDL() {
      return fnSortingDropdown(this.cityOptions);
    },
    jobTitleDDL() {
      return fnSortingDropdown(this.jobTitleOptions);
    },
    hobbiesDDL() {
      return fnSortingDropdown(this.hobbiesOptions);
    },
    productInterestDDL() {
      return fnSortingDropdown(this.productInterestOptions);
    },
  },
  async mounted() {
    await this.getSalesPersonListAction().then(() => {
      this.SalesPersonList.map((v, i) =>
        this.optionsSalesPerson.push({
          value: v.id,
          text: `${v.firstName}` + " " + `${v.lastName}`,
        })
      );
    });
    await this.getSegmentsAction()
      .then((response) => {})
      .catch((response) => {
        console.log(response);
      });
    await this.loadAndRefreshDetails();
  },

  methods: {
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("customerModule", [
      "getProfileDetailsListAction",
      "addProfileDetailAction",
      "deleteCustomerProfileDetailAction",
    ]),
    ...mapActions("segmentModule", [
      "getSegmentsAction",
      "removeSegmentAction",
      "addSegmentAction",
      "updateSegmentAction",
    ]),
    async loadAndRefreshDetails() {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the details are loading...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      const typeArrays = {
        SOURCE: this.sourceOptions,
        PRODUCTINTEREST: this.productInterestOptions,
        CITY: this.cityOptions,
        JOBTITLE: this.jobTitleOptions,
        HOBBIE: this.hobbiesOptions,
      };
      await this.getProfileDetailsListAction().then((response) => {
        for (const [type, optionsArray] of Object.entries(typeArrays)) {
          const filteredData = this.details.filter(
            (item) => item.type === type
          ).sort((a, b) => a.name.localeCompare(b.name));
          optionsArray.splice(
            0,
            optionsArray.length,
            ...filteredData.map((item) => ({
              value: item.id,
              text: item.name,
              itemTitle:
                type === "PRODUCTINTEREST" || "HOBBIE" ? item.name : undefined,
            }))
          );
        }
      });
      this.$swal.close();
    },
    showModal(type) {
      this.modalType = type;
      this.modalId = `modal-${type.toLowerCase()}`;
      this.modalTitle = `Add ${this.getModalTitle(type)}`;

      this.currentOptions = this[`${type.toLowerCase()}Options`];
      this.$nextTick(() => {
        this.$bvModal.show(this.modalId);
      });
    },
    getModalTitle(type) {
    switch (type.toLowerCase()) {
      case "hobbie":
        return "Hobbies";
      case "productinterest":
        return "Product Interest";
      case "city":
        return "City";
      case "jobtitle":
        return "Job Title";
      default:
        return "Unknown Type";
    }
  },
  addItem() {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the item is being added...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      // Validate character limits for "JOBTITLE" and "SOURCE" types
      if (
        (this.modalType === "JOBTITLE" && this.newItem.length > 100) ||
        (this.modalType === "SOURCE" && this.newItem.length > 50)
      ) {
        // Show SweetAlert if character limit is exceeded
        this.$swal({
          title: "Error!",
          text:
            this.modalType === "JOBTITLE"
              ? "Job title should not exceed 100 characters."
              : "Source should not exceed 50 characters.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      const payload = {
        name: this.newItem,
        type: this.modalType,
      };

      this.addProfileDetailAction(payload)
        .then(() => {
          this.loadAndRefreshDetails();
          this.showSuccessAlert("Item added successfully!");
          this.newItem = "";
          this.$bvModal.hide(this.modalId);
        })
        .catch((error) => {
        // console.log(error);
        console.log("This is an error: ", error);
         // Extract error message from the API response
      let errorMsg = "Failed to add item.";
      if (error.response?.data?.message) {
        errorMsg = error.response.data.message; // This ensures we show the correct backend error
      }

      // Display the error message using SweetAlert
      this.$swal({
        title: "Error!",
        text: errorMsg,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    });
      this.newItem = "";
      this.$bvModal.hide(this.modalId);
    },

    deleteItem(value) {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the item is being deleted...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.deleteCustomerProfileDetailAction(value)
        .then(() => {
          this.loadAndRefreshDetails();
          this.showSuccessAlert("Item deleted successfully!");
        })
        .catch((error) => {
          this.showErrorAlert("Failed to delete item: " + error.message);
          this.$swal.close();
        });
    },
    showErrorAlert(errorMessage) {
      this.$swal({
        title: "Error!",
        text:
          errorMessage || "An error occurred while adding the profile detail",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    showSuccessAlert(message) {
      this.$swal({
        title: "Success!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    resetForm() {
      // Your form submission
      this.$refs.formIndividual.reset(); // This will clear that form
    },
    async submitForm() {
      this.individual.additionalFields = undefined ? [] : this.individual.additionalFields;
      // emit the data to another page
      this.$emit("onchange", this.individual);
      let isValid = await this.$refs.formIndividual.validate();
      return isValid;
    },
    additionalFieldChanges(customFields) {
      this.individual.additionalFields = customFields;
    },
  },
  watch: {
    "individual.dob"(newDate) {
      // Ensure that the year is within the range 1900 to 2100
      const year = new Date(newDate).getFullYear();
      console.log("year", year);
      if (year < 1900 || year > 2100) {
        // If the year is outside the range, set it to the nearest boundary
        const nearestYear = Math.min(Math.max(year, 1900), 2100);
        // Update individual.dob to the nearest year
        this.individual.dob = new Date(newDate);
        this.individual.dob.setFullYear(nearestYear);
        // Display a sweet alert to inform the user about the range
        this.$swal.fire({
          title: "Invalid Year",
          text: `Please select a year between 1900 and 2100.`,
          icon: "warning",
          confirmButtonText: "OK",
        });
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
